import React from "react";
import {
  Box,
  Typography,
  Link,
  Checkbox,
  FormControlLabel,
  TextField,
  InputAdornment,
  Grid,
} from "@mui/material";

const BetslipWarnings = ({
  // warnings & helpers
  betslipLength,
  visibility,
  statchk,
  teamchk,
  restrictplayer,
  warningMsg,
  pastdatewarning,
  howtoplay,
  fantasypts,
  // entry / coupons
  userverification,
  filteredCoupons,
  selectedCoupons,
  handleCheckboxChange,
  formatAmount,
  newvalue,
  betvalue,
  maxinput,
  mininput
}) => {
  return (
    <Box>
      {betslipLength > 0 && visibility ? (
        <Grid container sx={{ mb: 2 }}>
          <Grid item xs={12} className="w-100">
            <Box
              sx={{
                borderBottom: "3px solid #ED1A3B",
                px: 1.25,
              }}
            />
          </Grid>
        </Grid>
      ) : (
        ""
      )}
      {/* Roster stat warning */}
      {!statchk && betslipLength > 1 ? (
        <Box className="two-btn-flex2" sx={{ mb: "15px" }}>
          <Typography component="h6" sx={{ color: "#0D3862" }}>
            Your roster includes more than 2 stats from the same player. You can
            only add a maximum of 2 stats for each player in your roster. Please
            update your roster to submit your lineup.
          </Typography>
        </Box>
      ) : (
        <Box>
          {/* Team mix warning */}
          {!teamchk && betslipLength > 1 ? (
            <Box className="two-btn-flex2" sx={{ mb: "15px" }}>
              <Typography component="h6" sx={{ color: "#0D3862" }}>
                Please select at least 1 player from another team. Your team
                cannot consist of all players from the same team.
              </Typography>
            </Box>
          ) : (
            <Box>
              {/* Restrict players per game warning */}
              {restrictplayer && betslipLength > 6 ? (
                <Box className="two-btn-flex2" sx={{ mb: "15px" }}>
                  <Typography component="h6" sx={{ color: "#0D3862" }}>
                    You can not select more than 6 players from the same game.
                    To add more players, please select from another event.
                  </Typography>
                </Box>
              ) : (
                ""
              )}
            </Box>
          )}
        </Box>
      )}

      {/* Empty state helper */}
      {betslipLength == 0 && (
        <Box
          className="two-btn-flex2"
          sx={{ display: visibility ? "" : "none", mt: "20px" }}
        >
          <Typography component="h6" sx={{ color: "#0D3862" }}>
            Select up to 10 players to build your team.
          </Typography>
          <Typography component="h6">
            <Link component="button" onClick={howtoplay} underline="hover">
              How to play
            </Link>{" "}
            <Typography component="span" sx={{ color: "#0D3862" }}>
              and
            </Typography>{" "}
            <Link component="button" onClick={fantasypts} underline="hover">
              Fantasy Points
            </Link>
          </Typography>
        </Box>
      )}

      {/* Need at least 2 players */}
      {betslipLength == 1 && (
        <Box className="two-btn-flex2">
          <Typography component="h6">
            Please select at least 2 players to create your team.
          </Typography>
        </Box>
      )}

      {/* Odds change warning */}
      {warningMsg && (
        <Box className="two-btn-flex2" sx={{ mt: "5px", mb: "5px" }}>
          <Typography component="h6">
            Sorry, one of your player's stats has changed. Please review your
            ticket and submit it again
          </Typography>
        </Box>
      )}

      {/* Past-date warning */}
      {pastdatewarning && (
        <Box className="two-btn-flex2" sx={{ mt: "5px", mb: "5px" }}>
          <Typography component="h6">
            One or more of your player's games have already started. The players
            have been removed from your team. Please review your team again and
            select new players if required.
          </Typography>
        </Box>
      )}

      {/* Coupons + Entry Fee */}
      {/* {userverification === "0" ? (
        ""
      ) : ( */}
        
        <Box>
          {betslipLength < 2 ? (
            ""
          ) : (
            <Box className="main-input-box column-vertical-center-flex">
              {filteredCoupons?.length > 0 ? (
                <Box className="justify-equaly mb-4">
                  <Box className="flex-basis-grow mr-8">
                    <Box className="flex-basic-grow2 input-div-border2">
                      <Box className="grow-flex-basis-start">
                        <Box className="input-with-symbol input-with-symbol-coupon flex-center-start">
                          <Box className="checkbox-container">
                            {filteredCoupons.map(
                              (coupon) =>
                                (selectedCoupons === null ||
                                  selectedCoupons === coupon?.id_coupon) && (
                                  <Box
                                    key={coupon.id_coupon}
                                    className="single-coupon"
                                  >
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          id={`coupon-${coupon.id_coupon}`}
                                          value={coupon.id_coupon}
                                          className="checkbox-coupon"
                                          onChange={handleCheckboxChange(
                                            coupon
                                          )}
                                          checked={
                                            selectedCoupons === coupon.id_coupon
                                          }
                                        />
                                      }
                                      label={
                                        <Typography className="coupon-text">
                                          Use your $
                                          {formatAmount(coupon?.amount)} Coupon
                                          for this entry.
                                        </Typography>
                                      }
                                    />
                                  </Box>
                                )
                            )}
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              ) : (
                ""
              )}

              {filteredCoupons.length > 0 ? (
                <Typography variant="body2" sx={{ textAlign: "center" }}>
                  OR set an entry fee below.
                </Typography>
              ) : (
                ""
              )}

              <TextField
                type="text"
                label="ENTRY FEE"
                fullWidth
                value={newvalue}
                onChange={betvalue}
                disabled={!!selectedCoupons}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography sx={{ fontSize: 24, fontWeight: 700 }}>
                        $
                      </Typography>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  sx: {
                    fontWeight: "bold",
                    letterSpacing: 2,
                    fontSize: 14,
                    color: "#374151",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    bgcolor: "#FFFFFF",
                    "& fieldset": {
                      borderColor: "#2E7D32",
                      borderWidth: 2,
                    },
                    "&:hover fieldset": {
                      borderColor: "#2E7D32",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2E7D32",
                    },
                    // minHeight: 80,
                  },
                  "& .MuiOutlinedInput-input": {
                    fontSize: 22,
                    fontWeight: 600,
                    pl: 1,
                  },
                }}
              />

              <Typography variant="body1" sx={{ mb: 1, color: "#0D3862", fontWeight: 500 }}>
                (min: ${mininput}, max: ${maxinput})
              </Typography>

            </Box>
          )}
        </Box>
      
      {/* // )} */}
    </Box>
  );
};

export default BetslipWarnings;
